var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurple02Mobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 676.67 2174.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 326,
    y1: 1439.91,
    x2: 326,
    y2: 763.24,
    gradientTransform: "translate(1439.91 761.27) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6465f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9233e9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M664.61,242.26c47.29,140.22-58.11,193.43-83,431-27.51,262.58,91.37,292.01,78,584-8.4,183.54-58.34,236.66-75.91,340.77-3.2,18.97-4.74,35.24-5.36,49.52-1.5,34.81-.13,62.06,1.26,77.71,9.84,110.57,40.5,177.05,28.37,247.04-17.2,99.21-111.98,157.07-122,163-97.77,57.82-243.2,52.3-316-20-112.26-111.48,63.8-266.94-26.37-563.04-34.45-113.12-79-204.88-121.04-394.78-8.11-36.61-12.01-78.71-8.96-131.22,12.88-221.72,122.33-252.68,100-445C91.33,389.34-26.88,340.87,5.61,215.26,36.3,96.6,176.5,5.67,313.61.26c168.3-6.64,308.67,116.49,351,242Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple02Mobile);
export default __webpack_public_path__ + "static/media/purple_02_mobile.82f52101218d39b5d766330d18768690.svg";
export { ForwardRef as ReactComponent };